"use client";

import React from "react";
import { MapPin, Phone, Mail, Loader, Send, Camera } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function IniziamoIlRacconto() {
  return <section id="iniziamo-il-racconto" className="dark bg-background text-foreground py-20 md:py-32 px-4 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--color-primary)_0%,_transparent_30%)] opacity-10 pointer-events-none" />
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div className="flex flex-col h-full justify-center space-y-10">
            <div className="relative group perspective-1000 mx-auto lg:mx-0 w-full max-w-md">
              {}
              <div className="relative bg-[#F2E8D5] text-[#1a1a1a] p-8 md:p-12 shadow-2xl transform transition-transform duration-700 hover:rotate-1 hover:scale-[1.01] border border-[#d4c5a9]">
                
                {}
                <div className="absolute inset-3 border-2 border-[#1a1a1a] opacity-80" />
                <div className="absolute inset-4 border border-[#1a1a1a] opacity-40" />
                
                {}
                <div className="absolute top-3 left-3 w-6 h-6 border-t-4 border-l-4 border-[#1a1a1a]" />
                <div className="absolute top-3 right-3 w-6 h-6 border-t-4 border-r-4 border-[#1a1a1a]" />
                <div className="absolute bottom-3 left-3 w-6 h-6 border-b-4 border-l-4 border-[#1a1a1a]" />
                <div className="absolute bottom-3 right-3 w-6 h-6 border-b-4 border-r-4 border-[#1a1a1a]" />

                <div className="relative z-10 flex flex-col items-center text-center space-y-6">
                  {}
                  <div className="w-16 h-16 rounded-full border-2 border-[#1a1a1a] flex items-center justify-center mb-2">
                    <Camera className="w-8 h-8" />
                  </div>

                  <h3 className="font-serif tracking-widest uppercase font-bold border-b-2 border-[#1a1a1a] pb-2 !text-2xl">ITALIAN MINUTEROS</h3>
                  
                  <p className="font-serif italic text-lg opacity-90">"Vintage Style Portraits"</p>

                  <div className="w-full h-px bg-[#1a1a1a] opacity-30 my-4" />

                  <div className="space-y-3 font-mono text-sm tracking-wide w-full">
                    <div className="flex items-center justify-center gap-3">
                      <MapPin className="w-4 h-4 shrink-0" />
                      <span>Str. San Marco, 81/c, 06131 Perugia, Italia</span>
                    </div>
                    <div className="flex items-center justify-center gap-3">
                      <Phone className="w-4 h-4 shrink-0" />
                      <Link to="tel:+393939309343" className="hover:underline decoration-1 underline-offset-2">+39 393 9309343</Link>
                    </div>
                    <div className="flex items-center justify-center gap-3">
                      <Mail className="w-4 h-4 shrink-0" />
                      <Link to="mailto:info@vignarolistudio.it" className="hover:underline decoration-1 underline-offset-2">info@vignarolistudio.it</Link>
                    </div>
                  </div>
                </div>
              </div>
              
              {}
              <div className="absolute -bottom-4 left-4 right-4 h-8 bg-black/40 blur-xl rounded-[50%] -z-10" />
            </div>

            <div className="text-center lg:text-left space-y-4 max-w-md mx-auto lg:mx-0">
              <h4 className="text-2xl font-serif text-primary">Book an Experience</h4>
            </div>
          </div>

          {}
          <div className="bg-card border border-border p-6 md:p-10 shadow-xl relative">
            {}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-32 h-8 bg-white/10 rotate-1 backdrop-blur-sm border-l border-r border-white/5" />

            <div className="mb-8 text-center lg:text-left">
              <h2 className="text-3xl md:text-4xl font-serif text-foreground mb-3">Let’s Start the Story</h2>
              <p className="text-muted-foreground">Enter your details below to start your journey through time.</p>
            </div>

            <FormProvider formId="story_form_contact" sectionName="contact-section" defaultValues={{
            name: "",
            email: "",
            phone: "",
            event_date: "",
            location: "",
            story: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true
            },
            story: {
              required: true
            }
          }} submitText="Submit Your Story" successMessage="Grazie! La tua storia è stata ricevuta. Ti contatteremo presto per sviluppare insieme i dettagli." errorMessage="Si è verificato un errore nell'invio. Per favore riprova.">
              <ContactForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control,
    resetForm
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-16 text-center space-y-6 animate-in fade-in zoom-in duration-500">
        <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center border border-primary/20">
          <Send className="w-10 h-10 text-primary" />
        </div>
        <div className="space-y-2">
          <h3 className="text-2xl font-serif text-foreground">Message Received</h3>
          <p className="text-muted-foreground max-w-xs mx-auto">Thank you! Your story has been received. We will contact you soon to develop the details together.</p>
        </div>
        <Button variant="outline" onClick={resetForm} className="mt-4 border-primary/30 hover:bg-primary/10">Send another message</Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="name" render={({
        field
      }) => <FormItem>
              <FormLabel>Your Name</FormLabel>
              <FormControl>
                <input className="flex h-11 w-full rounded-none border-b border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 transition-colors" placeholder="Mario Rossi" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" render={({
        field
      }) => <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <input type="email" className="flex h-11 w-full rounded-none border-b border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 transition-colors" placeholder="mario@example.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel>Phone Number</FormLabel>
              <FormControl>
                <input type="tel" className="flex h-11 w-full rounded-none border-b border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 transition-colors" placeholder="+39 333 1234567" {...field} />
              </FormControl>
              <FormDescription className="text-xs">Helps us get back to you faster..</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="event_date" render={({
        field
      }) => <FormItem>
              <FormLabel>Your Event Date</FormLabel>
              <FormControl>
                <input type="date" className="flex h-11 w-full rounded-none border-b border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 transition-colors [color-scheme:dark]" {...field} />
              </FormControl>
              <FormDescription className="text-xs">If you already have a date.</FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="location" render={({
      field
    }) => <FormItem>
            <FormLabel>Event Venue</FormLabel>
            <FormControl>
              <input className="flex h-11 w-full rounded-none border-b border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 transition-colors" placeholder="Roma, Piazza Navona" {...field} />
            </FormControl>
            <FormDescription className="text-xs">Event city or location.</FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="story" render={({
      field
    }) => <FormItem>
            <FormLabel>Share Your Story</FormLabel>
            <FormControl>
              <textarea className="flex min-h-[120px] w-full rounded-none border-b border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 resize-y transition-colors" placeholder="Tell us about your event, your vision, and the moments you’d love us to capture..." {...field} />
            </FormControl>
            <FormDescription className="text-xs">Providing more details allows us to further customize the service to your needs.</FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 text-destructive text-sm rounded-sm">
          {submitError}
        </div>}

      <div className="pt-4">
        <Button type="submit" className="w-full md:w-auto min-w-[200px] font-serif tracking-wide" size="lg" disabled={isSubmitting}>Check Availability</Button>
      </div>
    </Form>;
}